import {Form} from "../../../utils/Form";
import {
    UpdateCallGroupMutation,
    UpdateCallGroupMutationVariables,
    useUpdateCallGroupMutation,
} from "../queries.generated";
import {areObjectsEqual, compareCallBarrings} from "../../../tools";

export default class CallGroupSettingsForm extends Form<UpdateCallGroupMutation, UpdateCallGroupMutationVariables> {
    protected canEditOperator: boolean;

    constructor(initialData: UpdateCallGroupMutationVariables, canEditOperator: boolean) {
        super("updateCallGroup");
        this.hooks(useUpdateCallGroupMutation, initialData);
        this.canEditOperator = canEditOperator;
    }

    protected override get filteredVariables(): UpdateCallGroupMutationVariables {
        const values = structuredClone(this.values);
        if (!this.canEditOperator) delete values.outgoingCallBarringOperator;
        return values;
    }

    override get hasChanged(): boolean {
        const initialData = structuredClone(this.initialData);
        delete initialData.outgoingCallBarringAdmin;
        delete initialData.outgoingCallBarringOperator;

        const values = structuredClone(this.values);
        delete values.outgoingCallBarringAdmin;
        delete values.outgoingCallBarringOperator;

        return (
            !compareCallBarrings(this.initialData.outgoingCallBarringAdmin, this.values.outgoingCallBarringAdmin) ||
            !compareCallBarrings(
                this.initialData.outgoingCallBarringOperator,
                this.values.outgoingCallBarringOperator,
            ) ||
            !areObjectsEqual(initialData, values)
        );
    }
}
